<template>
  <header>
    <div class="logo"><img src="@/assets/lancul-logo-new.jpeg"></div>
  </header>
</template>

<script>

export default {
  name: 'Header'
}
</script>

<style scoped>
header {
  background-color: #efefef;
  padding: 18px 16px 14px;
  width: 100%;
  height: 60px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

header .logo {
  display: flex;
  justify-content: flex-start;
}

header .logo > img {
  width: 120px;
  height: 33.2333px;
}

@media (max-width: 768px) {
  header {
    padding: 9px 12px 11px;
    height: 50px;
  }

  header .logo {
    justify-content: center;
  }
}
</style>
